
const defaultUserFields: any = {
  length: {
    state: 'default',
    message: 'Incluir entre 6 y 12 caracteres alfanuméricos',
  },
  specialChars: {
    state: 'default',
    message: 'No usar espacios en blanco ni caracteres especiales. Ejemplo: ! " # $ % & \' ( ) * + , - . / : ; < = > ? @ [ \\ ] ^ _ ` { | } ~',
  },
}

const validUserFields: any = {
  length: {
    state: 'check',
    message: 'Incluir entre 6 y 12 caracteres alfanuméricos',
  },
  specialChars: {
    state: 'check',
    message: 'No usar espacios en blanco ni caracteres especiales. Ejemplo: ! " # $ % & \' ( ) * + , - . / : ; < = > ? @ [ \\ ] ^ _ ` { | } ~',
  },
}

const invalidUserFields: any = {
  length: {
    state: 'error',
    message: 'Incluir entre 6 y 12 caracteres alfanuméricos',
  },
  specialChars: {
    state: 'error',
    message: 'No usar espacios en blanco ni caracteres especiales. Ejemplo: ! " # $ % & \' ( ) * + , - . / : ; < = > ? @ [ \\ ] ^ _ ` { | } ~',
  },
}

const defaultPasswordFields: any = {
  length: {
    state: 'default',
    message: 'Incluir al menos 8 caracteres'
  },
  leastOneUpperLowerCaseChars: {
    state: 'default',
    message: 'Incluir al menos 1 mayúscula y 1 minúscula'
  },
  leastOneSpecialChar: {
    state: 'default',
    message: 'Incluir al menos 1 número o 1 carácter especial. Ejemplo: ! " # $ % & \' ( ) * + , - . / : ; < = > ? @ [ \\ ] ^ _ ` { | } ~',
  },
  consecutiveChars: {
    state: 'default',
    message: 'No colocar más de 2 caracteres iguales seguidos'
  },
  progressiveChars: {
    state: 'default',
    message: 'No colocar más de 4 caracteres consecutivos (ascendentes o descendentes)'
  },
  personalData: {
    state: 'default',
    message: 'No colocar datos personales o de tu entidad'
  },
  userDifferentToKey: {
    state: 'default',
    message: 'La contraseña debe ser distinta del usuario'
  },
}

const validPasswordFields: any = {
  length: {
    state: 'check',
    message: 'Incluir al menos 8 caracteres'
  },
  leastOneUpperLowerCaseChars: {
    state: 'check',
    message: 'Incluir al menos 1 mayúscula y 1 minúscula',
  },
  leastOneSpecialChar: {
    state: 'check',
    message: 'Incluir al menos 1 número o 1 carácter especial. Ejemplo: ! " # $ % & \' ( ) * + , - . / : ; < = > ? @ [ \\ ] ^ _ ` { | } ~',
  },
  consecutiveChars: {
    state: 'check',
    message: 'No colocar más de 2 caracteres iguales seguidos'
  },
  progressiveChars: {
    state: 'check',
    message: 'No colocar más de 4 caracteres consecutivos (ascendentes o descendentes)'
  },
  personalData: {
    state: 'check',
    message: 'No colocar datos personales o de tu entidad'
  },
  userDifferentToKey: {
    state: 'check',
    message: 'La contraseña debe ser distinta del usuario'
  },
}

const invalidPasswordFields: any = {
  length: {
    state: 'error',
    message: 'Incluir al menos 8 caracteres',
  },
  leastOneUpperLowerCaseChars: {
    message: 'Incluir al menos 1 mayúscula y 1 minúscula',
    state: 'error',
  },
  leastOneSpecialChar: {
    message: 'Incluir al menos 1 número o 1 carácter especial. Ejemplo: ! " # $ % & \' ( ) * + , - . / : ; < = > ? @ [ \\ ] ^ _ ` { | } ~',
    state: 'error',
  },
  consecutiveChars: {
    state: 'error',
    message: 'No colocar más de 2 caracteres iguales seguidos'
  },
  progressiveChars: {
    state: 'error',
    message: 'No colocar más de 4 caracteres consecutivos (ascendentes o descendentes)'
  },
  personalData: {
    state: 'error',
    message: 'No colocar datos personales o de tu entidad'
  },
  userDifferentToKey: {
    state: 'error',
    message: 'La contraseña debe ser distinta del usuario'
  }
}

export { defaultUserFields, validUserFields, invalidUserFields, defaultPasswordFields, validPasswordFields, invalidPasswordFields }